// SearchTokensController
// Inserts a query token (e.g. `location:""`) into the page's search box so admins
// can discover and use the search syntax. Bound to the index card header, which
// wraps both the search input and the "Search by" dropdown.
//
// Usage:
//   <div data-controller="search-tokens"> … <input name="q"> …
//     <button data-action="search-tokens#insert" data-search-tokens-token-param="location:">

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  insert({ params: { token } }) {
    const input = this.element.querySelector("input[name='q']");
    if (!input) return;

    // Already in the query? Don't duplicate — drop the caret into its value.
    const existing = this.valueCaret(input.value, token);
    if (existing !== -1) {
      this.focusAt(input, existing);
      return;
    }

    // Insert `token""` and land the caret between the quotes, so the admin types
    // the value there. Quoting keeps multi-word values intact for the parser.
    const trimmed = input.value.trimEnd();
    input.value = `${trimmed ? `${trimmed} ` : ""}${token}""`;
    this.focusAt(input, input.value.length - 1);
  }

  // Caret position inside an existing `token` (matched at a word boundary so we
  // don't match the token inside another value), or -1 if it isn't present.
  valueCaret(value, token) {
    let from = 0;
    while (true) {
      const i = value.indexOf(token, from);
      if (i === -1) return -1;
      if (i === 0 || value[i - 1] === " ") {
        const caret = i + token.length;
        return value[caret] === '"' ? caret + 1 : caret; // step inside an opening quote
      }
      from = i + token.length;
    }
  }

  focusAt(input, caret) {
    input.focus();
    input.setSelectionRange(caret, caret);
  }
}
